import { Component, OnInit } from '@angular/core';
import { Widget, Dashboard } from 'src/api/models'
import { IWidgetEditor, WidgetType, TimeLapseWidget } from 'src/app/models/dashboard';

@Component({
  selector: 'app-time-lapse-widget-editor',
  templateUrl: './time-lapse-widget-editor.component.html',
  styleUrls: ['./time-lapse-widget-editor.component.css']
})
export class TimeLapseWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: TimeLapseWidget;
  public dashboard: Dashboard;
  public w: any;
  
  constructor() {}

  ngOnInit() {
    this.w = <any>this.widget;
    if (this.w.timeSeriesList == null) { 
      this.w.timeSeriesList = [];
    } 
    
    if (this.w.timeSeriesList.length === 0) {
      this.w.timeSeriesList.push({ uri: "", sourceType: "Media" });
    }
  }

  addImageFeed(){
    this.w.timeSeriesList.push({
      uri: "",
      transforms: []
    });
  }

  public removeImageFeed(timeSeries: any): void {
    var index = this.w.timeSeriesList.indexOf(timeSeries);
    if (index > -1) {
      this.w.timeSeriesList.splice(index, 1);
    }
  }

}
